import { render } from "./header.vue?vue&type=template&id=eba4ecea&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=eba4ecea&scoped=true&lang=css"

import exportComponent from "D:\\code2\\demo2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba4ecea"]])

export default __exports__